import React from 'react'
import { Row, Col, FormGroup, Checkbox } from 'react-bootstrap'
import i18next from 'i18next'
import queryString from 'query-string'
import classnames from 'classnames'

import GridContainer from './GridContainer'
import SideBox from './SideBox'

import buttonStyles from './styles/button.scss'
import adminStyles from './styles/admin.scss'

import introductionIllustration from './../assets/images/wopi-puzzle.png'

const makeUrl = (organisationId, shouldDownloadExpiredData) => {
  const params = {
    'include-expired': shouldDownloadExpiredData ? 1 : undefined
  }

  return `/api/organisations/${organisationId}/profiles/wopi/all?${queryString.stringify(params)}`
}

export default class OrganisationData extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      shouldDownloadExpiredData: false
    }
  }

  handleShouldDownloadExpiredData = e => {
    this.setState({ shouldDownloadExpiredData: e.target.checked })
  }

  render() {
    return (
      <GridContainer>
        <header>
          <h1>{i18next.t('organisation_data')}</h1>
        </header>

        <SideBox>
          <div className={adminStyles.container}>
            <Row>
              <Col sm={12}>
                <h3>{i18next.t('download_organisation_explanation_heading')} </h3>

                <Row>
                  <Col xs={12} style={{}}>
                    <div>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: i18next
                            .t('download_organisation_explanation_content')
                            .replace(/\\n/g, '<br/>')
                        }}
                      />

                      <img src={introductionIllustration} style={{ width: 150, float: 'right' }} />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </SideBox>

        <section style={{ marginBottom: 40, backgroundColor: '#FFF8F4', padding: 20 }}>
          <div className={adminStyles.container}>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Checkbox
                    name="includeExpired"
                    checked={this.state.shouldDownloadExpiredData}
                    onChange={this.handleShouldDownloadExpiredData}
                  >
                    {i18next.t('download_organisation_wopi_csv_include_expired')}
                  </Checkbox>
                </FormGroup>

                <a
                  href={makeUrl(
                    this.props.currentOrganisationId,
                    this.state.shouldDownloadExpiredData
                  )}
                  download
                >
                  <button
                    className={classnames(
                      buttonStyles.button,
                      buttonStyles.buttonBlock,
                      buttonStyles.buttonLarge
                    )}
                  >
                    {i18next.t('download_organisation_wopi_csv')}
                  </button>
                </a>
              </Col>
            </Row>
          </div>
        </section>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganisationData.js